import { fetchAll, fetchFiltered, add, edit, show } from "@/api/consultant";

const state = {
  all: [],
  isLoading: false,
  consultantById: null,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchAll({ dispatch, commit }) {
    try {
      const consultants = await fetchAll();
      commit("setAll", consultants);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchById({ dispatch, commit }, id) {
    try {
      const consultant = await show(id);
      commit("setConsultantById", consultant);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchFiltered({ dispatch, commit }, queriesParams) {
    try {
      const consultants = await fetchFiltered(queriesParams);
      commit("setAll", consultants);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async edit({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);
    try {
      await edit(id, data);
      return true;
    } catch (e) {
      dispatch("notify/error", msg, { root: true });
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async create({ dispatch, commit }, status) {
    commit("setLoading", true);
    try {
      await add(status);
      return true;
    } catch (e) {
      dispatch("notify/error", msg, { root: true });
    } finally {
      commit("setLoading", false);
    }
    return false;
  },
};

const mutations = {
  setAll(state, consultant) {
    state.all = consultant;
  },

  setConsultantById(state, consultant) {
    state.consultantById = consultant;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },

  cleanState(state) {
    state.all = [];
    state.isLoading = false;
    state.consultantById = null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
